<script>
    import { default as pointAttributes } from "../notebooks/point-attributes";
    import EditableReport from './EditableReport.svelte'
    import {pinReportTopics} from "./pin-report/topics";
    import { ol, proj4 } from './mapping/ol';
    import {createEventDispatcher} from "svelte";


    export let report;
    export let reportLink = '';
    export let editing = false;
    export let editable = false;

    const SUMMARY = 'summary';
    const LRIS_KEY = "62404461eb8c4d388c613122b945cb36";

    let subject = undefined;

    $: {
        if (report && report.subject !== subject) {
            console.log('subject changed');
            subject = report.subject;
        }
    }

    // $: subject = report && report.subject;

    $: header = {
        showTitle: false,
        extraClass: 'pin-header report-header-topic',
        sections: [
            {
                notebookViews: [
                    {
                        notebook: pointAttributes,
                        cells: ['report', 'viewof map', 'mapLoaded'],
                        overrides: new Map([
                            ['pointSubject', subject],
                            ['linzKey', LRIS_KEY],
                            ['olModules', ol],
                            ['css', undefined],
                            ...proj4(),
                        ])
                    }
                ]
            }
        ]
    };



    $: categories = pinReportTopics(report);

    // let rootElement;
    let topicState = report && report.topics || {};

    const dispatch = createEventDispatcher();

    function onReportUpdated (event) {
        report = {
            ...report,
            ...event.detail
        };

        if (event.detail && event.detail.topics) {
            topicState = event.detail.topics;
        }

        dispatch('reportUpdated', report);
    }
</script>

<style>
    :global(.report-header-topic .frag-notebook) {
        display: flex;
    }

    :global(.report-header-topic [data-cell=mapLoaded]) {
        display: none;
    }

    :global(.report-header-topic [data-cell=report]) {
        flex: 1;
    }

    :global(.report-header-topic [data-cell=report]) {
        width: auto;
    }

    @media print {
        :global(.oe-pin-report .observablehq) {
            break-inside: unset;
            page-break-inside: unset;
        }
    }



    :global(.oe-pin-report .report-attribute) {
        break-inside: avoid;
    }
</style>

<EditableReport extraClass="oe-pin-report" {editable} {report} {reportLink} {editing} {header} {categories} {topicState}  reportKind="Point report" iconClass="icon icon-pin" on:reportUpdated={onReportUpdated}></EditableReport>
